import { NgModule } from '@angular/core';
import { SharedModule } from 'app/components/shared.module';
import { SectionModule } from 'app/views/presentations/layouts/layouts/section.module';
import { ThreeSectionsLayout3, ThreeSectionsLayout3Component } from 'app/views/presentations/layouts/layouts/threeSectionsLayout3/threeSectionsLayout3.component';
import { LayoutWrapperModule } from 'app/views/presentations/layouts/layoutWrapper.module';

@NgModule({
    imports: [
        SharedModule,
        SectionModule,
        LayoutWrapperModule.wrapLayout(ThreeSectionsLayout3)
    ],
    declarations: [
        ThreeSectionsLayout3Component
    ],
    entryComponents: [
        ThreeSectionsLayout3Component
    ]
})
export class ThreeSectionsLayout3Module { }


// WEBPACK FOOTER //
// ./src/app/views/presentations/layouts/layouts/threeSectionsLayout3/threeSectionsLayout3.module.ts